(function () {
  'use strict';

  var VARIANT_CHANGE_EVENT = 'variant-change';

  function initBIS(sectionId) {
    var wrapper = document.getElementById('bis-form-wrapper-' + sectionId);
    if (!wrapper) return;

    var form = document.getElementById('bis-form-' + sectionId);
    var emailInput = form && form.querySelector('.bis-email');
    var submitBtn = form && form.querySelector('.bis-submit');
    var successMsg = wrapper.querySelector('.bis-success');
    var atcButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!form || !emailInput || !successMsg || !atcButton) return;

    var bisVariantId = document.getElementById('bis-variant-id-' + sectionId);
    var bisVariantTitle = document.getElementById('bis-variant-title-' + sectionId);

    function showBIS() {
      atcButton.style.display = 'none';
      wrapper.style.display = '';
    }

    function showATC() {
      atcButton.style.display = '';
      wrapper.style.display = 'none';
      if (!successMsg.hidden) {
        successMsg.hidden = true;
        form.hidden = false;
        emailInput.value = '';
      }
    }

    function handleVariant(vid, available) {
      if (bisVariantId) bisVariantId.value = vid;
      if (bisVariantTitle && window.productVariantsMeta) {
        var meta = window.productVariantsMeta[String(vid)];
        if (meta && meta.vtitle) bisVariantTitle.value = meta.vtitle;
      }
      if (available) { showATC(); } else { showBIS(); }
    }

    // Wacht tot subscribe beschikbaar is (pubsub.js laadt met defer)
    function trySubscribe(attempts) {
      if (typeof subscribe === 'function') {
        subscribe(VARIANT_CHANGE_EVENT, function(event) {
          var data = event && event.data ? event.data : event;
          var variant = data && data.variant;
          var html = data && data.html;
          if (!variant) return;

          var available = !!variant.available;
          if (html) {
            var newBtn = html.querySelector('[id^="ProductSubmitButton-"]');
            if (newBtn) available = !newBtn.hasAttribute('disabled');
          }
          handleVariant(String(variant.id), available);
        });

        // Initieel controleren
        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (idInput && window.productVariants) {
          var v = window.productVariants.find(function(pv) {
            return String(pv.id) === String(idInput.value);
          });
          if (v) handleVariant(idInput.value, v.available);
        }
      } else if (attempts > 0) {
        setTimeout(function() { trySubscribe(attempts - 1); }, 100);
      }
    }

    // Start pogingen na DOMContentLoaded
    trySubscribe(30); // max 3 seconden wachten

    // Formulier submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      emailInput.classList.remove('bis-email--error');

      var email = emailInput.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emailInput.classList.add('bis-email--error');
        emailInput.focus();
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Bezig...';

      var variantId = form.querySelector('[name="variant_id"]').value;
      var productId = form.querySelector('[name="product_id"]').value;
      var productTitle = form.querySelector('[name="product_title"]').value;
      var variantTitle = form.querySelector('[name="variant_title"]').value;
      var productUrl = form.querySelector('[name="product_url"]').value;
      var productImage = form.querySelector('[name="product_image"]').value;

      var payload = new FormData();
      payload.append('form_type', 'customer');
      payload.append('utf8', '\u2713');
      payload.append('customer[email]', email);
      payload.append('customer[tags]', 'back-in-stock');
      payload.append('customer[note]', JSON.stringify({
        type: 'back_in_stock',
        variant_id: variantId,
        product_id: productId,
        product_title: productTitle,
        variant_title: variantTitle,
        product_url: productUrl,
        product_image: productImage,
        signed_up_at: new Date().toISOString()
      }));

      fetch('/contact', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: payload
      })
      .then(function () {
        form.hidden = true;
        successMsg.hidden = false;
      })
      .catch(function () {
        try {
          var existing = JSON.parse(localStorage.getItem('mc_bis_signups') || '[]');
          existing.push({ email: email, variantId: variantId, productId: productId, productTitle: productTitle, variantTitle: variantTitle, productUrl: productUrl, signedUpAt: new Date().toISOString() });
          localStorage.setItem('mc_bis_signups', JSON.stringify(existing));
        } catch(_) {}
        form.hidden = true;
        successMsg.hidden = false;
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Houd mij op de hoogte';
      });
    });
  }

  function setup() {
    document.querySelectorAll('[id^="bis-form-wrapper-"]').forEach(function (el) {
      var sectionId = el.id.replace('bis-form-wrapper-', '');
      initBIS(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

})();
